import { useParams } from 'react-router-dom';

import { type CollectionChainType } from '@app/client';
import { PathParams } from '@app/routes/types';

interface UseGetSlugChainArgs {
    type?: 'daas' | 'yat';
    providedChain?: string;
    providedSlug?: string;
    unified?: boolean;
}
// conditional return type with overload
// https://blog.devgenius.io/conditional-return-type-for-function-overloading-in-typescript-e3c53b9a1fcb#:~:text=TypeScript%20playgound.-,Conditional%20Return%20Type,-Question%3A%20how
// https://www.typescriptlang.org/docs/handbook/declaration-files/by-example.html#overloaded-functions
type UnifiedOrChain = <T extends UseGetSlugChainArgs>(
    args: T,
) => T extends { unified: true } ? string : CollectionChainType;

export function useGetSlugChain(args?: UseGetSlugChainArgs) {
    const { [PathParams.Chain]: chain, collectionSlugParam } = useParams();
    const _collectionSlug = args?.providedSlug || collectionSlugParam;

    function func(args: UseGetSlugChainArgs & { returnAsObject: false }): CollectionChainType;
    function func(args: UseGetSlugChainArgs & { returnAsObject?: true }): string;
    function func(args: UseGetSlugChainArgs): CollectionChainType | string {
        let _chain: CollectionChainType;
        if (args?.type === 'daas') {
            _chain = (chain || '') as CollectionChainType;
        } else {
            _chain = chain ? (getFormattedChain(chain) as CollectionChainType) : ('' as CollectionChainType);
        }
        if (args?.unified && _collectionSlug) {
            return `${args.providedChain || _chain}.${_collectionSlug}` as string;
        }
        return _chain as CollectionChainType;
    }

    const generateFunc = (): UnifiedOrChain => func;
    return generateFunc()({ ...args });
}

export const getFormattedChain = (chain: string) => chain?.charAt(0)?.toUpperCase() + chain?.slice(1);
